import DashboardLayout from "@layouts/dashboard";

const Dashboard = () => {
    return (
        <DashboardLayout title="داشبورد">
            <div></div>
        </DashboardLayout>
    );
};

export default Dashboard;
